
import {defineComponent,ref,reactive,nextTick,computed} from 'vue'
import { delOrg,addOrg,editOrg} from '@/service/main/system/systemApi';
import {getInventoryPage,createNoOrder} from '@/service/main/invoices'
import { ElMessage, ElMessageBox } from 'element-plus';
import { exportExcel } from "@/utils/exportExcel";
import Pagination from '@/components/Pagination/index.vue'
import {statusEnum} from '@/utils/enum'
import {useStore} from '@/store' 
export default defineComponent({
  components: {
    Pagination
  },
  setup() {
    const store = useStore();
    //库位类型枚举
    const storageTypeeEnum = computed(() => store.state.login.enums.locationType);
    //查询
    const formModel = ref({
      wareLocationCode: '',
      locTypeId: '',
      wareMaterialName: '',
      wareContainerCode: '',
      wareContainerName: '',
      wareMaterialCode: '',
      beginDate: '',
      endDate: '',
      pageNo: 1,
      pageSize: 10,
      ReceiveDate: []
    });

    //仓库类型列表
    let tableData = ref([]);

    //列表的数据条数
    const totalItems = ref<number>(0);

    //获取菜单列表
    const getTabelData = () => {
      //判断完成时间是否有选择
      if(formModel.value.ReceiveDate.length > 0) {
          formModel.value.beginDate = formModel.value.ReceiveDate[0];
          formModel.value.endDate = formModel.value.ReceiveDate[1];
      }
      getInventoryPage(formModel.value).then(res => {
        console.log(res)
        if(res.code == 200) {
          const {data} = res;
          const result = data;
          tableData.value = result.rows;
          totalItems.value = result.totalRows;
        }else {
          ElMessage.error(`${res.code}:${JSON.stringify(res.message)}`)
        } 
      }).catch(err => {
        console.log(err)
        ElMessage.error(JSON.stringify(err))
      })
    }

    getTabelData();

    //重置搜索
    const resetForm = () => {
      formModel.value = {
        wareLocationCode: '',
        locTypeId: '',
        wareMaterialName: '',
        wareContainerCode: '',
        wareContainerName: '',
        wareMaterialCode: '',
        beginDate: '',
        endDate: '',
        pageNo: 1,
        pageSize: 10,
        ReceiveDate: []
      }
      getTabelData();
    }

    //选中的行
    const checkRows = ref<any[]>([]);

    // 选择
    const handleSelectionChange = (val: any) => {
      checkRows.value = val;
    }
    //导出
    const handExport = () => {
      let entozh = {
          id: "序号",
          wareMaterialCode: "物料编号",
          wareMaterialName: "物料名称",
          layer: "层",
          column: "列",
          row: "排",
          quantity: '物料数量',
          occQuantity: '实收数量',
          wareContainerCode: '容器编号',
          ordersNo: '入库单',
          lane: '巷道',
          createdTime: '入库时间',
          wareLocationCode: '库位编号'
        };
      exportExcel(checkRows.value, entozh, "xlsx", "库存记录信息表");
    }

    //创建出库单
    const handleBatchDelete = () => {
      const params: {sourceBy: number;data: any[];orderType: number} = {
        sourceBy: 0,
        orderType: 6,
        data: []
      }
      checkRows.value.forEach(item => {
        const itemObj = {
          wareContainerCode: item.wareContainerCode,
          wareMaterialCode: item.wareMaterialCode,
          batchNo: item.itemBatchNo,
          quantity: item.quantity
        }
        params.data.push(itemObj);
      })
      ElMessageBox.confirm('是否确认创建出库单？','提示',{
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        createNoOrder(params).then((res: any) => {
          if(res?.code === 200) {
            ElMessage.success('出库单创建成功')
            // 刷新列表
            getTabelData()
          }else {
            ElMessage.error(`出库单创建失败${res?.code}:${JSON.stringify(res.message)}`)
          }
        }).catch((err: any) => {
          console.log(err);
          ElMessage.error(JSON.stringify(err))
        })
      }).catch(() =>{
        ElMessage.info('已取消创建')
      })
    }

    //删除
    const deleteRole = (code: number) => {
      const obj = {id: [code]};
      ElMessageBox.confirm('是否确认删除？','提示',{
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delOrg(obj).then((res: any) => {
          if(res?.code === 200) {
            ElMessage.success('删除成功')
            // 刷新列表
            getTabelData()
          }else {
            ElMessage.error(`删除失败${res?.code}:${res.message}`)
          }
        }).catch((err: any) => {
          console.log(err);
          ElMessage.error(`删除失败${err}`)
        })
      }).catch(() =>{
        ElMessage.info('已取消删除')
      })
    }

    //窗口类型
    const dialogType = ref('add')

    const dialogVisible = ref(false);

    //操作表单ref
    const dialogRef = ref();

    //打开窗口
    const openDialog  = (type:number,scope: any = {}) => {
      if(type == 1) {
        dialogType.value = 'add'
      }else {
        dialogType.value = 'edit'
        addForm.name = scope.name;
        addForm.remark = scope.remark;
        addForm.id = scope.id;
        addForm.code = scope.code;
        addForm.tel = scope.tel;
      }
      dialogVisible.value = true;
      nextTick(() => {
        dialogRef.value.clearValidate();
      })
    }
    //添加/编辑
    let addForm = reactive({
      orgType: 1,
      name: '',
      code: '',
      remark: '',
      status: 0,
      tel: '',
      id: '',
      pid: '0',
      pids: '0'
    })
    // 校验邮箱格式
    var validatorEmail = (rule: any, value: any, callback: any) => {
        const mailReg = /^([a-zA-Z\d][\w-]{2,})@(\w{2,})\.([a-z]{2,})(\.[a-z]{2,})?$/;
        if (!value) {
            return callback(new Error("邮箱不能为空"));
        }
        setTimeout(() => {
            if (mailReg.test(value)) {
                callback();
            } else {
                callback(new Error("请输入正确的邮箱格式"));
            }
        }, 100);
    };
    //rules
    const formRules = {
      name: [{required: true,message: '部门名称不能为空',trigger: 'blur'}],
      code: [{required: true,message: '部门编码不能为空',trigger: 'blur'}],
      remark: [{required: true,message: '部门备注不能为空',trigger: 'blur'}],
      tel: [{required: true,message: '邮件地址不能为空',trigger: 'blur'},{validator: validatorEmail,trigger: 'blur'}]
    }

    //操作提交
    const confirm = () => {
      dialogRef.value.validate((vali: any) => {
        if(vali) {
          //添加
          if(dialogType.value == 'add') {
            addOrg(addForm).then(res => {
             
                ElMessage.success('添加成功');
                getTabelData();
                dialogVisible.value = false;
              
            }).catch(err => {
              console.log(err)
            })
          }else {
            editOrg(addForm).then(res => {
              
                ElMessage.success('编辑成功');
                getTabelData();
                dialogVisible.value = false;
              
            }).catch(err => {
              console.log(err)
            })
          }
        }else {
          ElMessage.warning('表单验证失败');
        }
      })
      
    }
  
    //关闭窗口
    const closeDialog = () => {
      addForm.id = '';
      addForm.code = '';
      addForm.name = '';
      addForm.remark = '';
      addForm.tel = '';
    }
    
    
    return {
      formModel,
      tableData,
      getTabelData,
      resetForm,
      checkRows,
      handleSelectionChange,
      handExport,
      handleBatchDelete,
      deleteRole,
      dialogType,
      dialogVisible,
      dialogRef,
      addForm,
      formRules,
      confirm,
      closeDialog,
      totalItems,
      openDialog,
      statusEnum,
      storageTypeeEnum
    }
  }
})
